import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ApiService, Faq } from '../../services/api.service';

@Component({
  selector: 'app-transarchitect',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './transarchitect.component.html'
})
export class TransarchitectComponent implements OnInit {
  faqs: Faq[] = [];

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    // We can reuse the FAQs from the rental module or create specific ones.
    this.api.getFaqs('Rental').subscribe({
      next: (data) => {
        if (data && data.length > 0) {
          this.faqs = data;
        } else {
          this.loadFallbackFaqs();
        }
      },
      error: () => this.loadFallbackFaqs()
    });
  }

  private loadFallbackFaqs(): void {
    this.faqs = [
      { id: 1, question: 'How is vehicle availability updated?', answer: 'Availability is updated in real-time across all channels as soon as a booking is confirmed or a vehicle is returned. Our system ensures you never overbook and have full visibility into your fleet\'s status at any given second.', module: 'TransArchitect', sortOrder: 1 },
      { id: 2, question: 'Can we automate invoice generation?', answer: 'Yes, the system can be configured to generate and send invoices automatically based on rental milestones, return dates, or customized triggers.', module: 'TransArchitect', sortOrder: 2 },
      { id: 3, question: 'Are maintenance alerts configurable?', answer: 'Absolutely. You can set triggers based on mileage, engine hours, or specific calendar dates for each vehicle type.', module: 'TransArchitect', sortOrder: 3 },
      { id: 4, question: 'Does the ERP handle tax compliance?', answer: 'Yes, TransArchitect supports multi-regional tax rules, VAT, and specific local transportation levies out of the box.', module: 'TransArchitect', sortOrder: 4 },
      { id: 5, question: 'Can I track driver performance?', answer: 'The HR module includes driver-specific KPIs, tracking safety records, punctuality, and fuel efficiency metrics.', module: 'TransArchitect', sortOrder: 5 },
      { id: 6, question: 'Is data migration supported?', answer: 'Our specialized migration team helps you transition your existing legacy data into TransArchitect with minimal downtime.', module: 'TransArchitect', sortOrder: 6 }
    ];
  }
}
